import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import moment from "moment/moment";

const store = new Vuex.Store({
    state: {
        // url: "http://localhost:3000/",
        url: process.env.VUE_APP_URL_SERVICES,
        store_url: process.env.VUE_APP_URL_IMAGE,
        userid: null,
        Cargando: false,
        userSucursal: null,
        username: null,
        email: null,
        isAuth: false,
        jwt: "",
        isAdmin: false,
        firstName: null,
        lastName: null,
        rol: null,
        hideConfigButton: false,
        isPinned: true,
        showConfig: false,
        sidebarType: "bg-gradient-dark",
        isRTL: false,
        color: "success",
        isNavFixed: false,
        isAbsolute: false,
        showNavs: true,
        showSidenav: true,
        showNavbar: true,
        showFooter: true,
        showMain: true,
        isDarkMode: false,
        autorizado: false,
        user: null,
        navbarFixed:
            "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
        absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
        bootstrap,
        permisos: null,
        // Nuevo sistema de permisos
        userPermissions: [],
        userRole: null,
        // Estado de cotización
        quoteData: {
            cliente: null,
            vehiculo: null,
            prestamo: {
                modalidad: "GPS",
                montoPrestamo: 0,
                gpsPagadoPorCliente: false
            }
        },
    },
    mutations: {
        toggleConfigurator(state) {
            state.showConfig = !state.showConfig;
        },
        toggleEveryDisplay(state) {
            state.showNavbar = !state.showNavbar;
            state.showSidenav = !state.showSidenav;
            state.showFooter = !state.showFooter;
        },
        toggleHideConfig(state) {
            state.hideConfigButton = !state.hideConfigButton;
        },
        setIsPinned(state, payload) {
            state.isPinned = payload;
        },
        color(state, payload) {
            state.color = payload;
        },
        navbarMinimize(state) {
            const sidenavShow = document.getElementsByClassName("g-sidenav-show")[0];
            if (sidenavShow.classList.contains("g-sidenav-pinned")) {
                sidenavShow.classList.remove("g-sidenav-pinned");
                sidenavShow.classList.add("g-sidenav-hidden");
                state.isPinned = true;
            } else {
                sidenavShow.classList.remove("g-sidenav-hidden");
                sidenavShow.classList.add("g-sidenav-pinned");
                state.isPinned = false;
            }
        },
        navbarFixed(state) {
            if (state.isNavFixed === false) {
                state.isNavFixed = true;
            } else {
                state.isNavFixed = false;
            }
        },
        storeId(state, id) {
            state.userid = id;
        },
        doLogin(state) {
            state.isAuth = true;
        },
        doLogout(state) {
            state.isAuth = false;
            state.username = null;
            state.firstName = null;
            state.lastName = null;
            state.jwt = "";
            state.isAdmin = false;
            // Limpiar sessionStorage (nuevo sistema)
            sessionStorage.removeItem("authData");
            sessionStorage.removeItem("token");
            // Limpiar localStorage (sistema anterior)
            localStorage.removeItem("token");
            localStorage.removeItem("isAuth");
            localStorage.removeItem("username");
            localStorage.removeItem("email");
            localStorage.removeItem("userid");
            localStorage.removeItem("firstName");
            localStorage.removeItem("lastName");
            localStorage.removeItem("userSucursal");
        },
        setToken(state, token) {
            state.jwt = token;
        },
        isAdmin(state) {
            state.isAdmin = true;
        },
        SetPermisos(state, permisos) {
            state.permisos = permisos;
        },
        setUserPermissions(state, permissions) {
            state.userPermissions = permissions || [];
        },
        setUserRole(state, role) {
            state.userRole = role;
        },
        // Mutaciones para cotización
        setQuoteData(state, quoteData) {
            state.quoteData = { ...state.quoteData, ...quoteData };
        },
        /** Reemplazo completo del estado de cotización (para edición: evita mezclar con datos previos). */
        setQuoteDataFull(state, quoteData) {
            const prestamo = quoteData?.prestamo && typeof quoteData.prestamo === 'object' ? { ...quoteData.prestamo } : state.quoteData.prestamo;
            state.quoteData = quoteData && typeof quoteData === 'object'
                ? { cliente: quoteData.cliente ?? null, vehiculo: quoteData.vehiculo ?? null, prestamo }
                : state.quoteData;
        },
        setQuoteCliente(state, cliente) {
            state.quoteData.cliente = cliente;
        },
        setQuoteVehiculo(state, vehiculo) {
            state.quoteData.vehiculo = vehiculo;
        },
        setQuotePrestamo(state, prestamo) {
            state.quoteData.prestamo = prestamo;
        },
        clearQuoteData(state) {
            state.quoteData = {
                cliente: null,
                vehiculo: null,
                prestamo: {
                    modalidad: "GPS",
                    montoPrestamo: 0,
                    gpsPagadoPorCliente: false
                }
            };
        }
    },
    actions: {
        setColor({commit}, payload) {
            commit("color", payload);
        },
        storeId({commit}, id) {
            commit("storeId", id);
        },
        doLogin({commit}) {
            commit("doLogin");
        },
        doLogout({commit}) {
            commit("doLogout");
        },
        setToken({commit}, token) {
            commit("setToken", token);
        },
        isAdmin({commit}) {
            commit("isAdmin");
        },
        guardarPermisos({commit}, permisos) {
            commit("SetPermisos", permisos);
        },
        setUserPermissions({commit}, permissions) {
            commit("setUserPermissions", permissions);
        },
        setUserRole({commit}, role) {
            commit("setUserRole", role);
        },
        // Acciones para cotización
        setQuoteData({commit}, quoteData) {
            commit("setQuoteData", quoteData);
        },
        setQuoteDataFull({commit}, quoteData) {
            commit("setQuoteDataFull", quoteData);
        },
        setQuoteCliente({commit}, cliente) {
            commit("setQuoteCliente", cliente);
        },
        setQuoteVehiculo({commit}, vehiculo) {
            commit("setQuoteVehiculo", vehiculo);
        },
        setQuotePrestamo({commit}, prestamo) {
            commit("setQuotePrestamo", prestamo);
        },
        clearQuoteData({commit}) {
            commit("clearQuoteData");
        }
    },
    getters: {
        tienePermiso: (state) => (permiso) => {
            let check = false;
            if (state.rol === "Super Administrador") {
                check = true;
            } else if (state.permisos !== null) {
                state.permisos.forEach(item => {
                    if (item.name === permiso) {
                        check = true;
                    }
                });
            }
            return check;
        },
        // Nuevos getters para el sistema de permisos
        hasPermission: (state) => (permission) => {
            // Si es Administrador, tiene todos los permisos
            if (state.userRole === "Administrador") {
                return true;
            }
            // Verificar si el permiso está en la lista
            return state.userPermissions && state.userPermissions.includes(permission);
        },
        canDelete: (state) => (module) => {
            // Solo Administrador puede eliminar
            if (state.userRole === "Administrador") {
                return true;
            }
            // Supervisor y Agente no pueden eliminar
            return false;
        },
        isRole: (state) => (role) => {
            return state.userRole === role;
        },
        isAdmin: (state) => {
            return state.userRole === "Administrador";
        },
        isSupervisor: (state) => {
            return state.userRole === "Supervisor";
        },
        isAgente: (state) => {
            return state.userRole === "Agente";
        },
        // Getters para cotización
        getQuoteData: (state) => state.quoteData,
        getQuoteCliente: (state) => state.quoteData.cliente,
        getQuoteVehiculo: (state) => state.quoteData.vehiculo,
        getQuotePrestamo: (state) => state.quoteData.prestamo,
        isQuoteComplete: (state) => {
            return state.quoteData.cliente && 
                   state.quoteData.vehiculo && 
                   state.quoteData.prestamo;
        }
    },
    plugins: [createPersistedState({
        paths: ['color', 'isRTL', 'isNavFixed', 'showSidenav', 'showNavbar', 'showFooter', 'sidebarType', 'isPinned', 'showConfig', 'hideConfigButton', 'isDarkMode', 'quoteData']
    })]
});

export default store;
